import type { GetSupportedPaymentMethodsResponse_PaymentMethod } from '@jotta/grpc-connect-openapi/payment'
import { exhaustiveGuard } from '@jotta/utils/exhaustive'

export enum PaymentMethodOption {
  STRIPE_CARD,
  STRIPE_PAYPAL,
  VIPPS,
}

export function paymentMethodOptions(
  paymentMethods: GetSupportedPaymentMethodsResponse_PaymentMethod[],
) {
  return paymentMethods?.flatMap(value => {
    const type = value.type
    switch (type.case) {
      case undefined:
        return []
      case 'stripe':
        return [
          PaymentMethodOption.STRIPE_CARD,
          PaymentMethodOption.STRIPE_PAYPAL,
        ]
      case 'vipps':
        return [PaymentMethodOption.VIPPS]
      default:
        return exhaustiveGuard(type)
    }
  })
}
